export { SearchCircle as default } from './SearchCircle';
